// Store assembly inspection-doc zip exports keyed by id.
import { GET_PROJECT_QA_ASSEMBLY_EXPORTS, GET_PROJECT_QA_ASSEMBLY_EXPORT, CREATE_PROJECT_QA_ASSEMBLY_EXPORT } from "./actions";

export function ProjectQaAssemblyExportsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_PROJECT_QA_ASSEMBLY_EXPORTS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_PROJECT_QA_ASSEMBLY_EXPORT}_FULFILLED`:
    case `${CREATE_PROJECT_QA_ASSEMBLY_EXPORT}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    default:
      return state;
  }
}
